import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbupcydxgs: FaireProductEntity = {
  token: "p_cbupcydxgs",
  type: "product",
  name: "Colima Coarse Sea Salt (500g)",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/71e347cf3418c86753f6bc3e2ccca6e55552a0233c37543eb5d7411631458c41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c98a0c4ee67d4ccf5894a680f61aadb772510e017d9c447c6ba52518245a214.jpeg",
    "https://cdn.faire.com/fastly/fee648d0b9daf3e605a58118ab5041d776e73201c877c80d28592d96fb67c602.jpeg",
    "https://cdn.faire.com/fastly/480ca97cb3d3654fc01d360c471b48115e96169b47ee796585f4ddbe0170f76c.jpeg",
    "https://cdn.faire.com/fastly/4742779eb128f7e5a642d7fa9ff10e668b11333bdb5c8ba562745b5db8a2fb92.jpeg",
  ],
  priceDollars: 6,
  description:
    "Drawn from the sun-kissed Pacific waters of Colima, Mexico, this hand-harvested sea salt is rich in natural minerals and dried by the coastal breeze. Its clean, delicate flavor brings a touch of Mexico's coast to your kitchen. Colima Coarse Sea Salt is prized for its delicate, pyramid-shaped crystals and clean, briny flavor. \n\nIdeal for:\n   - Seasoning meats potatoes and veggies\n   - Sprinkling on ripe mango, watermelon, or avocado\n   - Adding a gourmet touch to baked goods.\n\nThis unrefined salt enhances dishes with both flavor and texture. Beautiful in a pinch bowl or salt cellar, it’s an essential for any kitchen that celebrates authentic, quality ingredients.\n\nHarvested and Made in Mexico. ",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:14.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
